/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Caution icon
 *
 * @file CautionIcon.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function CautionIcon(props) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11.9997 16.9336C12.621 16.9336 13.1247 17.4373 13.1247 18.0586C13.1247 18.6799 12.621 19.1836 11.9997 19.1836C11.3785 19.1834 10.8747 18.6798 10.8747 18.0586C10.8747 17.4374 11.3785 16.9338 11.9997 16.9336Z" fill="#171717" />
      <path d="M11.9997 8.3584C12.552 8.3584 12.9997 8.80611 12.9997 9.3584V15.0049C12.9994 15.5569 12.5518 16.0049 11.9997 16.0049C11.4477 16.0047 10.9999 15.5568 10.9997 15.0049V9.3584C10.9997 8.80622 11.4475 8.35858 11.9997 8.3584Z" fill="#171717" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0153 2.91797C12.7404 2.91853 13.2306 3.35228 13.5592 3.74609C13.879 4.12931 14.2099 4.67595 14.5739 5.27246L21.9967 17.4375C22.3901 18.082 22.7472 18.6623 22.9528 19.1475C23.1608 19.6385 23.336 20.3113 22.9616 20.9785C22.5871 21.6456 21.9217 21.8475 21.3942 21.9258C20.873 22.003 20.1912 22 19.4362 22H4.56802C3.81208 22 3.12968 22.0031 2.60806 21.9258C2.08025 21.8475 1.41402 21.6454 1.0397 20.9775L0.975251 20.8525C0.687024 20.2264 0.854763 19.6049 1.05045 19.1445C1.25682 18.6592 1.61489 18.0783 2.00943 17.4336L9.45377 5.26953C9.81851 4.67351 10.1502 4.12698 10.4704 3.74414C10.7995 3.35078 11.2903 2.91765 12.0153 2.91797ZM12.0036 5.02734C11.8014 5.26912 11.5595 5.66042 11.1598 6.31348L3.71549 18.4775C3.28545 19.1803 3.02472 19.6115 2.89029 19.9277C2.88797 19.9332 2.88661 19.9391 2.88443 19.9443C2.88989 19.9452 2.89626 19.9464 2.90201 19.9473C3.24184 19.9976 3.74487 20 4.56802 20H19.4362C20.2585 20 20.7608 19.9975 21.1003 19.9473C21.1057 19.9465 21.1117 19.9452 21.1169 19.9443C21.1147 19.9392 21.1142 19.9331 21.112 19.9277C20.9781 19.6118 20.7182 19.1817 20.2897 18.4795L12.8659 6.31445C12.467 5.66087 12.225 5.26932 12.0231 5.02734C12.0201 5.02383 12.0162 5.02095 12.0133 5.01758C12.0105 5.02091 12.0065 5.02383 12.0036 5.02734Z" fill="#171717" />
    </SvgIcon>
  );
}

export default CautionIcon;
